module.exports = __webpack_public_path__ + "img/yuyue.93486b79.png";